const translations = {
  en: {
    hello: 'Hello',
    membersince: 'Member since',
    logout: 'Sign out',
    mybooks: 'My books',
    findbook: 'Find book',
    stats: 'Stats',
    achievements: 'Achievements',
    locked: 'Locked',
    unlocked: 'Unlocked',
    achievementunlocked: 'Achievement unlocked',
    account: 'Account',
    tagline: 'Your personal reading companion.',
    signin: 'Sign in',
    register: 'Register',
    resetpassword: 'Reset password',
    signinMessage: 'Please sign in',
    passwordreset: 'Password reset email sent!',
    wrongcredentials: 'Wrong email or password.',
    registerMessage: 'Please register',
    passwordmissmatch: 'Password and Confirm Password do not match.',
    invalidemail: 'Invalid Email Address.',
    privacypolicy: 'Privacy policy',
    termsofservice: 'Terms of service',
    acceptterms: 'I accept the',
    terms: 'terms of service',
    accepttheterms: 'Accept terms',
    declinetheterms: 'Decline',
    backtosignin: 'Back to sign in',
    forgotpassword: 'Forgot password?',
    forgottenpassword: 'We all forget sometimes',
    emailLabel: 'Email address',
    passwordLabel: 'Password',
    nameLabel: 'Name',
    newPassword: 'New password',
    currentPassword: 'Current password',
    confirmpasswordLabel: 'Confirm password',
    passwordUpdateMessage: 'Password updated successfully!',
    passwordErrorMessage: 'Error updating password!',
    quoteLabel: 'Add quote',
    summaryLabel: 'Write summary',
    reviewLabel: 'Write a review',
    coverurl: 'Cover image link',
    rating: 'Rating',
    clear: 'Clear',
    review: 'Review',
    titleLabel: 'Title',
    authorLabel: 'Author',
    show: 'Show',
    hide: 'Hide',
    search: 'Search',
    preferedlanguage: 'Prefered language',
    any: 'Any',
    searchoptions: 'Search options',
    everything: 'Everything',
    title: 'Title',
    author: 'Author',
    subject: 'Subject',
    place: 'Place',
    person: 'Person',
    searching: 'Searching...',
    backtosearch: 'Back to search',
    start: 'Start',
    startsession: 'Start session',
    stop: 'Stop',
    manualsession: 'Manual session',
    cancelmanualsession: 'Cancel manual session',
    sessiondate: 'Date',
    sessiontime: 'Time',
    selectpagespeed: 'Reading speed',
    sessionbasedon: 'Based on selection',
    sessionavgspeed: 'Avg. reading speed',
    pagesperhour: 'pages/h',
    slow: 'Slow',
    medium: 'Average',
    fast: 'Fast',
    bookprogress: 'Book progress',
    addManually: 'or add a book manually.',
    searchLabel: 'Title, author, ISBN and more',
    sessionLow: 'session',
    sessionsLow: 'sessions',
    pageLow: 'page',
    pagesLow: 'pages',
    summaryLow: 'summary',
    summariesLow: 'summaries',
    quoteLow: 'quote',
    quotesLow: 'quotes',
    page: 'Page',
    pages: 'Pages',
    publisher: 'Publisher',
    published: 'Published',
    isbn: 'ISBN',
    other: 'Book ID',
    savebook: 'Save book',
    savetolist: 'Save to list',
    reading: 'Reading',
    currentlyreading: 'Currently reading',
    wanttoread: 'Want to read',
    haveread: 'Read',
    dnf: 'Did not finish',
    unknown: 'Unknown',
    savedto: 'saved to',
    movedto: 'moved to',
    deleted: 'deleted',
    wasupdated: 'was updated',
    bookexists: 'The book is already saved!',
    finishedreading: 'Good job! You finished reading',
    longeststreak: 'You have a new streak record',
    bookupdatedforsession: 'You can now start a session!',
    movetoreading: 'Move to reading',
    movetolist: 'Move to list',
    searchhistory: 'Search history',
    clearhistory: 'Clear history',
    summary: 'Summary',
    details: 'Details',
    bookdetails: 'Book details',
    editdetails: 'Edit details',
    notStarted: 'Not started',
    dateStarted: 'Date started',
    dateFinished: 'Date finished',
    dateCompleted: 'Date',
    pagesRead: 'Pages read',
    timeRead: 'Time read',
    deletebook: 'Delete book',
    confirmdeletebook: 'Confirm delete',
    backtodetails: 'Back to details',
    addmissinginfoMessage:
      'You have to update missing details from the book in order to start a session.',
    updatebook: 'Update book',
    updatebookNotification:
      'Please make sure you have filled out all required fields.',
    close: 'Close',
    cancel: 'Cancel',
    nosession: 'No session',
    nosessions: 'No sessions',
    nosummaries: 'No summaries',
    noquotes: 'No quotes',
    searchError:
      'Book not found. Please check the search input and try again or add the book manually.',
    saveError: 'Failed to save the book. Please try again.',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
    monday: 'Monday',
    sunday: 'Sunday',
    changestartweek: 'Change first day of week',
    nobookreadMessage: 'No book is marked as currently being read.',
    by: 'by',
    of: 'of',
    finishbook: 'Finish book',
    finishsession: 'Finish session',
    manualfinishsession: 'Save manual session',
    resumesession: 'Resume session',
    cancelsession: 'Cancel session',
    sessionduration: 'Session duration',
    manualsessionduration: 'Session date and time',
    updatepagesMessage: 'Update pages',
    pagesreadMessage: 'Pages read this session',
    addpersonalMessage: 'Add a personal touch',
    missingcover: 'Missing book cover',
    language: 'Language',
    usersettings: 'User settings',
    userimportexport: 'Import/export book data',
    usermanagement: 'User management',
    userfeedback: 'Feedback',
    userfeedbacklink: 'Send user feedback',
    feedbackheader: 'We value your feedback',
    feedbackmessage: `We'd love to hear from you—whether it's suggestions, issues, or general thoughts. Your input helps us improve!`,
    feedbackaction: 'Send a message to:',
    feedbacksubject: 'Feedback from Bookie',
    donate: 'Donate a coffee',
    changelanguage: 'Change language',
    english: 'English',
    swedish: 'Swedish',
    changetheme: 'Change theme',
    theme: {
      light: 'Light',
      dark: 'Dark',
    },
    changebookmark: 'Change bookmark',
    platinum: 'Legendary',
    gold: 'Gold',
    silver: 'Silver',
    bronze: 'Bronze',
    default: 'Default',
    exporttocsv: 'Export books to CSV data',
    importtocsv: 'Import books from CSV data',
    importhelpheader: 'Import books from a CSV file',
    importhelptext: `Easily upload your book data using a CSV file. Make sure your CSV includes key details like title, author, and reading dates. This will allow you to import your existing book collection into your Bookie account.`,
    importsubhelp: `A CSV file can be exported from most spread sheet editors such as Excel or Numbers.`,
    downloadexamplefile: 'Download an example CSV file',
    book: 'book',
    books: 'books',
    imported: 'imported',
    alreadyimported: 'already uploaded.',
    nothingimported: 'Nothing imported.',
    drophint: 'Drop your CSV file here or click to select.',
    selectfile: 'Select CSV file',
    pleaseselectfile: 'Please select a CSV file to upload.',
    nocsvfile: 'No CSV file selected.',
    csvprogress: 'Upload progress',
    installpwa: 'Install on mobile devices',
    installheader: 'For a smoother experience, add Bookie to your home screen',
    installios: 'Install on iOS and iPadOS',
    installandroid: 'Install on Android',
    install: {
      ios1: 'Open the Share menu.',
      ios2: 'Tap Add to Home Screen.',
      ios3: 'Confirm the name of the app.',
      ios4: 'Tap Add.',
      android1: 'Open the three-dot menu.',
    },
    changepassword: 'Change password',
    passworddetails: 'The password must be at least 6 characters long.',
    deleteallbooks: 'Delete all books',
    deleteaccount: 'Delete account',
    deleteaccountheader: 'Warning: Permanent account deletion',
    deleteaccounttext: `Deleting your account will permanently erase all your data, including all saved books and account details. This action is irreversible, and you will not be able to recover any data once the deletion is complete.`,
    deleteaccountconfirm: `To confirm and proceed with deleting your account, please enter your account email below:`,
    deleteaccountemail: 'Account email',
    reauthenticate: `You need to re-authenticate before deleting your account. Please log in again.`,
    accountdeleted: `User account deleted successfully.`,
    allbooksdeleted: `All books have been deleted.`,
    nobooksmatchingfilter: 'No books matches filter',
    filter: 'Filter books',
    sessionpattern: 'Session reading patterns',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    night: 'Night',
    weekdays: 'Weekdays',
    weekends: 'Weekends',

    d: 'day',
    ds: 'days',
    h: 'h',
    min: 'min',
    sec: 'sec',

    statTotalSessions: 'Total sessions',
    statAvgTimePerSession: 'Avg. time per session',
    statAvgPagePerSession: 'Avg. pages per session',
    statAvgTimePerPages: 'Avg. time per page',
    statAvgPagesPerHour: 'Avg. pages per hour',
    statTotalSessionTime: 'Total time read',
    statTotalSessionPages: 'Total pages read',
    statTotalBooks: 'Total books read',
    statTotalPages: 'Total pages read',
    statAvgBookTime: 'Avg. active time read per book',
    statAvgBookDuration: 'Avg. completion period per book',
    statAvgSessionsPerBook: 'Avg. sessions per book read',
    statPagesPerBook: 'Avg. pages per book read',
    statLongestStreak: 'Longest streak',
    statCurrentStreak: 'Current streak',
    statShortestSession: 'Shortest session',
    statLongestSession: 'Longest session',

    share: {
      finishsession: 'just finished a reading session!',
      finishbook: 'just finished reading a book!',
      sessioninfo: 'Session info',
      streak: 'Streak',
      sessions: 'Sessions',
      quote: 'Quote',
      share: 'Share',
      error:
        'Your device does not support direct sharing. The image will be downloaded instead. You can manually share it!',
    },

    timeperiod: 'Time period',
    alltime: 'All time',
    today: 'Today',
    yesterday: 'Yesterday',
    thisweek: 'This week',
    lastweek: 'Last week',
    thismonth: 'This month',
    lastmonth: 'Last month',
    thisyear: 'This year',
    lastyear: 'Last year',

    emptyFindBook: 'Find a book to read.',
    emptyFindNewBook: 'Find a new book to read',
    emptyNoBookProgress: `You haven't finished any books yet, but you are making great progress.`,
    emptyReading: 'There are no books listed as currently being read.',
    emptyWantToRead: `You don't have any books you want to read at the moment.`,
    emptyNoBooks: `You haven't finished any books yet.`,
    emptyGoToBooks: 'Go to my books',
    emptyStats: `Get stats by starting and finishing reading sessions. To start a session, you must first have a book in the currently reading list.`,
    emptyState: {
      reading: {
        quote: `There are two motives for reading a book: one, that you enjoy it; the other, that you can boast about it.`,
        author: 'Bertrand Russel',
        book: 'The Conquest of Happiness',
      },
      wanttoread: {
        quote: 'Bag end is a queer place, and its folks are even queerer',
        author: 'J. R. R. Tolkien',
        book: 'The Lord of the Rings',
      },
      read: {
        quote: `If you're going to read this, dont bother. After a couple pages, you won't want to be here. So forget it. Go away. Get out while you're still in one piece.`,
        author: 'Chuck Palahniuk',
        book: 'Choke',
      },
      stats: {
        quote: `Shakespeare is the happy hunting ground of all minds that have lost their balance.`,
        author: 'James Joyce',
        book: 'Ulysses',
      },
    },

    trophies: {
      firstbook: {
        name: 'First Book!',
        desc: 'Complete your first book.',
      },
      booksII: {
        name: 'Bookworm II',
        desc: 'Complete 3 books.',
      },
      booksIII: {
        name: 'Bookworm III',
        desc: 'Complete 6 books.',
      },
      booksIV: {
        name: 'Bookworm IV',
        desc: 'Complete 12 books.',
      },
      streakI: {
        name: 'Streak I',
        desc: 'Read for 7 consecutive days.',
      },
      streakII: {
        name: 'Streak II',
        desc: 'Read for 14 consecutive days.',
      },
      streakIII: {
        name: 'Streak III',
        desc: 'Read for 30 consecutive days.',
      },
      streakIV: {
        name: 'Streak IV',
        desc: 'Read for 60 consecutive days.',
      },
      readerI: {
        name: 'Marathon reader I',
        desc: 'Read for 30 minutes in a single day.',
      },
      readerII: {
        name: 'Marathon reader II',
        desc: 'Read for 1 hour in a single day.',
      },
      readerIII: {
        name: 'Marathon reader III',
        desc: 'Read for 2 hours in a single day.',
      },
      readerIV: {
        name: 'Marathon reader IV',
        desc: 'Read for 3 hours in a single day.',
      },
      pagesI: {
        name: 'Page turner I',
        desc: 'Read 100 pages.',
      },
      pagesII: {
        name: 'Page turner II',
        desc: 'Read 1,000 pages.',
      },
      pagesIII: {
        name: 'Page turner III',
        desc: 'Read 2,500 pages.',
      },
      pagesIV: {
        name: 'Page turner IV',
        desc: 'Read 5,000 pages.',
      },
      timeI: {
        name: 'Time well spent I',
        desc: 'Read 1 hour.',
      },
      timeII: {
        name: 'Time well spent II',
        desc: 'Read 10 hours.',
      },
      timeIII: {
        name: 'Time well spent III',
        desc: 'Read 50 hours.',
      },
      timeIV: {
        name: 'Time well spent IV',
        desc: 'Read 100 hours.',
      },
      sessionsI: {
        name: 'Sessionist I',
        desc: 'Completed your first session.',
      },
      sessionsII: {
        name: 'Sessionist II',
        desc: 'Completed 15 sessions.',
      },
      sessionsIII: {
        name: 'Sessionist III',
        desc: 'Completed 75 sessions.',
      },
      sessionsIV: {
        name: 'Sessionist IV',
        desc: 'Completed 150 sessions.',
      },
    },

    effectiveDate: 'Effective date',
    tos: {
      intro: `Welcome to Bookie! By using Bookie, you agree to the following terms and conditions. Please read them carefully.`,
      acceptance: 'Acceptance of terms',
      acceptanceMessage: `By accessing or using Bookie, you agree to be bound by these terms of service. If you do not agree with any part of these terms, please do not use Bookie.`,
      userdata: 'User data and privacy',
      userdataMessage: `Your privacy is important to us. By using Bookie, you consent to the collection, storage, and use of your data as described in our privacy policy.`,
      storage: 'Data storage',
      storageMessage: `To provide you with the best experience, Bookie stores user data, including but not limited to, reading preferences, session data, and user settings, on Google Firebase. By using Bookie, you consent to your data being stored and processed in Firebase. We use Firebase to ensure that your data is accessible across devices and is backed up securely. We also store some user settings and session data in the browser local storage.`,
      security: 'Security',
      securityMessage: `While we take reasonable precautions to protect your data, no security system is impenetrable. Therefore, we cannot guarantee the absolute security of your data. By agreeing to these terms, you acknowledge that you use Bookie at your own risk.`,
      service: 'Service continuity disclaimer',
      serviceMessage: `Bookie is a personal hobby project and is provided "as is" with no guarantee of long-term availability or continuity. The service may be modified, suspended, or discontinued at any time, without notice or liability to users.`,
      changes: 'Changes to terms',
      changesMessage: `We may update these terms of service from time to time. If changes are made, we will notify you by updating the "Effective date" at the top of this page. Your continued use of Bookie after such changes indicates your acceptance of the new terms.`,
    },

    pp: {
      intro: `At Bookie, your privacy is our top priority. This privacy policy explains how we collect, use, and protect your personal information when you use Bookie. By using Bookie, you agree to the practices described in this policy.`,
      informationHeader: 'Information we collect',
      informationMessage: `We collect the following types of information to provide you with a personalized and seamless reading experience:`,
      informationList1: `Personal information: When you create an account, we collect your name and email address.`,
      informationList2: `Usage data: We collect information related to your interactions with the app, such as your reading preferences, reading sessions, and usage patterns.`,
      usageHeader: 'How we use your information',
      usageMessage: `The information we collect is used solely to enhance your experience with Bookie. Specifically, we use your data to:`,
      usageList1: `Show statistics about your personal reading.`,
      usageList2: `Synchronize your reading progress and preferences across devices.`,
      usageList3: `Provide you with access to your saved data whenever you log in.`,
      usageExemptHeader: 'Importantly, Bookie does not:',
      usageExemptList1: `Sell your personal information to third parties.`,
      usageExemptList2: `Feed your data into algorithms to recommend books or other content.`,
      storageHeader: 'Data storage and security',
      storageMessage: `Your data is securely stored in Google Firebase and the website is served from GitHub.`,
      userControlHeader: 'User control: exporting and deleting your data',
      userControlMessage: `We believe in giving you full control over your data:`,
      userControlList1: `Data export: You can request an export of your book data at any time by using the built in export functionality. We will provide you with a copy of your data in a CSV format.`,
      userControlList2: `Account deletion: If you wish to delete your account and all associated data, you can do so by using the built in account deletion functionality. Once finished, all your data will be permanently deleted.`,
      dataRetentionHeader: 'Data retention',
      dataRetentionMessage: `We retain your data for as long as your account is active or as needed to provide you with our services. If you choose to delete your account, your data will be permanently removed.`,
      partiesHeader: 'Third-party services',
      partiesMessage: `Bookie use third-party services, such as Google Firebase and GitHub, to store and manage your data and serve the website. These services are governed by their own privacy policies.`,
      changesHeader: 'Changes to this privacy policy',
      changesMessage: `We may update this privacy policy from time to time. When we make changes, we will notify you by updating the "Effective date" at the top of this page. Your continued use of Bookie after any changes indicates your acceptance of the new policy.`,
    },
    superlatives: {
      l1: {
        first: 'Great',
        second: 'Nice',
        third: 'Good',
        fourth: 'Impressive',
      },
      l2: {
        first: 'Amazing',
        second: 'Wonderful',
        third: 'Fantastic',
        fourth: 'Awesome',
      },
      l3: {
        first: 'Incredible',
        second: 'Outstanding',
        third: 'Remarkable',
        fourth: 'Superb',
      },
      l4: {
        first: 'Phenomenal',
        second: 'Mind-blowing',
        third: 'Extraordinary',
        fourth: 'Epic',
      },
      l5: {
        first: 'Legendary',
        second: 'Unstoppable',
        third: 'Unbeatable',
        fourth: 'Supreme',
      },
    },
    hero: {
      cta: 'Learn how it works',
      cta2: 'Get started now',
      login: 'Go to login',
      subheader: 'Track your progress and rediscover the joy of reading',
      introtext: `Bookie is the ultimate companion app for book lovers. Whether you're tackling your next novel or building a reading streak, Bookie keeps you motivated with simple tools for tracking progress, and celebrating achievements.`,
      howitworks: 'How It Works',
      step1: 'Step 1: Add books to your shelf',
      step2: 'Step 2: Start reading',
      step3: 'Step 3: See your progress',
      step1text: `Quickly search by title, author, or ISBN to add books to your virtual bookshelf. Can’t find it? Add custom details for a seamless experience.`,
      step2text: `Kick off a session with one tap. Track time spent, pages read, and more, all while diving into your favorite stories.`,
      step3text: `View detailed stats and unlock fun achievements. Work towards achieving a perfect week by maintaining your streak and staying consistent. Keep the momentum alive as you build habits and celebrate progress.`,
      why: 'Why Bookie?',
      whytext: `In today’s busy world, it’s easy to lose track of your reading goals or forget the joy of diving into a great book. Bookie helps you stay consistent and inspired with personalized progress tracking, engaging stats, and motivational achievements. Whether you're an avid reader or just starting, Bookie transforms your reading into a fun, rewarding experience.`,
      didyouknow: 'Did you know?',
      didyouknowbullet1: `By reading 10 minutes every day you will finish 10 books in a year. This is based on an average reading speed of 45 pages per hour and an average book length of about 270 pages.`,
      didyouknowbullet2: `Reading strengthens the brain, boost creativity, enhances emotional intelligence and improves your vocabulary.`,
    },
  },
  sv: {
    hello: 'Hej',
    membersince: 'Medlem sedan',
    logout: 'Logga ut',
    mybooks: 'Mina böcker',
    findbook: 'Hitta bok',
    stats: 'Statistik',
    achievements: 'Medaljer',
    locked: 'Låsta',
    unlocked: 'Upplåsta',
    achievementunlocked: 'Medalj upplåst',
    account: 'Mitt konto',
    tagline: 'Din personliga läsekompis.',
    signin: 'Logga in',
    register: 'Registrera',
    resetpassword: 'Återställ lösenord',
    signinMessage: 'Var god och logga in',
    passwordreset: 'E-postmeddelande om lösenordsåterställning har skickats!',
    wrongcredentials: 'Felaktig e-postadress eller lösenord.',
    registerMessage: 'Var god och registrera dig',
    passwordmissmatch: 'Lösenord och Bekräfta lösenord stämmer inte överens.',
    invalidemail: 'Ogiltig e-postadress.',
    privacypolicy: 'Integritetspolicy',
    termsofservice: 'Användarvillkor',
    acceptterms: 'Jag accepterar',
    terms: 'användarvillkoren',
    accepttheterms: 'Acceptera villkoren',
    declinetheterms: 'Avböj',
    backtosignin: 'Tillbaka till inloggning',
    forgotpassword: 'Glömt lösenord?',
    forgottenpassword: 'Vi glömmer alla ibland',
    emailLabel: 'E-postadress',
    passwordLabel: 'Lösenord',
    nameLabel: 'Namn',
    newPassword: 'Nytt lösenord',
    currentPassword: 'Nuvarande lösenord',
    confirmpasswordLabel: 'Bekräfta lösenord',
    passwordUpdateMessage: 'Lösenordet har ändrats!',
    passwordErrorMessage: 'Error!',
    quoteLabel: 'Lägg till citat',
    summaryLabel: 'Skriv en summering',
    reviewLabel: 'Skriv en recension',
    coverurl: 'Länk till omslagsbild',
    rating: 'Betyg',
    clear: 'Rensa',
    review: 'Recension',
    titleLabel: 'Titel',
    authorLabel: 'Författare',
    show: 'Visa',
    hide: 'Dölj',
    search: 'Sök',
    preferedlanguage: 'Önskat språk',
    any: 'Valfritt',
    searchoptions: 'Sökalternativ',
    everything: 'Allt',
    title: 'Titel',
    author: 'Författare',
    subject: 'Ämne',
    place: 'Plats',
    person: 'Person',
    searching: 'Söker ...',
    backtosearch: 'Tillbaka till sök',
    start: 'Starta',
    startsession: 'Starta en session',
    stop: 'Stop',
    manualsession: 'Manuell session',
    cancelmanualsession: 'Avbryt manuell session',
    sessiondate: 'Datum',
    sessiontime: 'Tid',
    selectpagespeed: 'Läshastighet',
    sessionbasedon: 'Baserat på val',
    sessionavgspeed: 'Snitt läshastighet',
    pagesperhour: 'sidor/tim.',
    slow: 'Långsam',
    medium: 'Normal',
    fast: 'Snabb',
    bookprogress: 'Framsteg',
    addManually: 'eller lägg till boken manuellt.',
    searchLabel: 'Titel, författare, ISBN m.m.',
    sessionLow: 'session',
    sessionsLow: 'sessioner',
    pageLow: 'sida',
    pagesLow: 'sidor',
    summaryLow: 'summering',
    summariesLow: 'summeringar',
    quoteLow: 'citat',
    quotesLow: 'citat',
    page: 'Sida',
    pages: 'Sidor',
    publisher: 'Förlag',
    published: 'Utgiven',
    isbn: 'ISBN',
    other: 'Bok-id',
    savebook: 'Spara bok',
    savetolist: 'Lägg till i lista',
    reading: 'Läser',
    currentlyreading: 'Läser',
    wanttoread: 'Vill läsa',
    haveread: 'Läst',
    dnf: 'Avbrutna',
    unknown: 'Okänd',
    savedto: 'sparad i lista',
    movedto: 'flyttad till',
    deleted: 'har tagits bort',
    wasupdated: 'har uppdaterats',
    bookexists: 'Boken är redan sparad!',
    finishedreading: 'Bra jobbat! Du har läst ut',
    longeststreak: 'Du har ett nytt streak rekord',
    bookupdatedforsession: 'Du kan nu starta en session!',
    movetoreading: 'Flytta till läser',
    movetolist: 'Flytta till lista',
    searchhistory: 'Sökhistorik',
    clearhistory: 'Rensa historik',
    summary: 'Sammanfattning',
    details: 'Detaljer',
    bookdetails: 'Bokdetaljer',
    editdetails: 'Ändra detaljer',
    notStarted: 'Ej startad',
    dateStarted: 'Började läsa',
    dateFinished: 'Slutade läsa',
    dateCompleted: 'Datum',
    pagesRead: 'Sidor läst',
    timeRead: 'Tid läst',
    deletebook: 'Ta bort bok',
    confirmdeletebook: 'Bekräfta borttagning',
    backtodetails: 'Tillbaka till detaljer',
    addmissinginfoMessage:
      'Du måste uppdatera boken med följande för att kunna starta en session.',
    updatebook: 'Uppdatera bok',
    updatebookNotification: 'Se till att alla obligatoriska fält är ifyllda.',
    close: 'Stäng',
    cancel: 'Avbryt',
    nosession: 'Ingen session',
    nosessions: 'Inga sessioner',
    nosummaries: 'Inga summeringar',
    noquotes: 'Inga citat',
    searchError:
      'Hittade ingen bok. Pröva att ändra sökfras eller lägg till boken manuellt.',
    saveError: 'Kunde inte spara boken. Var god försök igen.',
    mon: 'Mån',
    tue: 'Tis',
    wed: 'Ons',
    thu: 'Tor',
    fri: 'Fre',
    sat: 'Lör',
    sun: 'Sön',
    monday: 'Måndag',
    sunday: 'Söndag',
    changestartweek: 'Ändra startdag för vecka',
    nobookreadMessage: 'Ingen bok är markerad som läses just nu.',
    by: 'av',
    of: 'av',
    finishbook: 'Avsluta bok',
    finishsession: 'Avsluta session',
    manualfinishsession: 'Spara manuell session',
    resumesession: 'Fortsätt session',
    cancelsession: 'Avbryt session',
    sessionduration: 'Sessionslängd',
    manualsessionduration: 'Sessionsdatum och tid',
    updatepagesMessage: 'Uppdatera sidor',
    pagesreadMessage: 'Sidor lästa denna session',
    addpersonalMessage: 'Lägg till något personligt',
    missingcover: 'Saknar omslag',
    language: 'Språk',
    usersettings: 'Användarinställningar',
    userimportexport: 'Importera/exportera bokdata',
    usermanagement: 'Användarhantering',
    userfeedback: 'Synpunkter',
    userfeedbacklink: 'Skicka feedback',
    feedbackheader: 'Vi värdesätter dina åsikter',
    feedbackmessage: `Vi vill gärna höra från dig - oavsett om det är förslag, problem eller allmänna tankar. Din feedback hjälper oss att bli bättre.`,
    feedbackaction: 'Skicka ett meddelande till:',
    feedbacksubject: 'Feedback från Bookie',
    donate: 'Bjud på en kaffe',
    changelanguage: 'Ändra språk',
    english: 'Engelska',
    swedish: 'Svenska',
    changetheme: 'Ändra tema',
    theme: {
      light: 'Ljust',
      dark: 'Mörkt',
    },
    changebookmark: 'Ändra bokmärke',
    platinum: 'Legendarisk',
    gold: 'Guld',
    silver: 'Silver',
    bronze: 'Brons',
    default: 'Standard',
    exporttocsv: 'Exportera till CSV',
    importtocsv: 'Importera CSV-data',
    importhelpheader: 'Importera din bokdata från CSV',
    importhelptext: `Ladda enkelt upp din bokdata med en CSV-fil. Se till att din CSV-fil innehåller nyckeldetaljer som titel, författare och datum för läsning. På så vis kan du importera din egen bokdata till ditt Bookie-konto.`,
    importsubhelp: `En CSV-fil can exporteras från de flesta kalkylbladsprogram som Excel och Numbers..`,
    downloadexamplefile: 'Ladda ner ett exempel på en CSV-fil',
    book: 'bok',
    books: 'böcker',
    imported: 'importerade',
    alreadyimported: 'redan importerade',
    nothingimported: 'Ingenting importerades',
    drophint: 'Släpp din CSV-fil här eller klicka för att välja.',
    selectfile: 'Välj CSV-fil',
    pleaseselectfile: 'Var god välj en CSV-fil att ladda upp.',
    nocsvfile: 'Ingen CSV-fil vald.',
    csvprogress: 'Laddar upp',
    installpwa: 'Installera på mobila enheter',
    installheader:
      'För en smidigare upplevelse, lägg till Bookie på din hemskärm',
    installios: 'Installera på iOS och iPadOS',
    installandroid: 'Installera på Android',
    install: {
      ios1: 'Öppna delningsmenyn.',
      ios2: 'Tryck på Lägg till på hemskärmen.',
      ios3: 'Bekräfta appens namn.',
      ios4: 'Tryck på Lägg till.',
      android1: 'Öppna menyn med tre prickar.',
    },
    changepassword: 'Ändra lösenord',
    passworddetails: 'Lösenordet måste vara minst 6 tecken långt.',
    deleteallbooks: 'Radera alla böcker',
    deleteaccount: 'Radera konto',
    deleteaccountheader: 'Varning: Permanent borttagning av konto',
    deleteaccounttext: `Att radera ditt konto kommer permanent att radera all din data, inklusive alla sparade böcker och kontouppgifter. Denna åtgärd är oåterkallelig, och du kommer inte att kunna återställa någon data när raderingen är genomförd.`,
    deleteaccountconfirm: `För att bekräfta och fortsätta med att radera ditt konto, ange ditt kontos epostadress nedan:`,
    deleteaccountemail: 'Epostadress',
    reauthenticate: `Du behöver återautentisera dig innan du kan radera ditt konto. Vänligen logga in igen.`,
    accountdeleted: `Användarkonto borttaget.`,
    allbooksdeleted: `Alla böcker har raderats.`,
    nobooksmatchingfilter: 'Inga böcker matchar filtret',
    filter: 'Filtrera böcker',
    sessionpattern: 'Läsmönster',
    morning: 'Morgon',
    afternoon: 'Eftermiddag',
    evening: 'Kväll',
    night: 'Natt',
    weekdays: 'Veckodagar',
    weekends: 'Helger',

    d: 'dag',
    ds: 'dagar',
    h: 'tim.',
    min: 'min.',
    sec: 'sek.',

    statTotalSessions: 'Antal sessioner',
    statAvgTimePerSession: 'Snitt tid per session',
    statAvgPagePerSession: 'Snitt sidor per session',
    statAvgTimePerPages: 'Snitt tid per sida',
    statAvgPagesPerHour: 'Snitt sidor per timme',
    statTotalSessionTime: 'Total tid läst',
    statTotalSessionPages: 'Totalt antal sidor lästa',
    statTotalBooks: 'Totalt antal böcker lästa',
    statTotalPages: 'Totalt antal sidor lästa',
    statAvgBookTime: 'Snitt tid att läsa ut en bok',
    statAvgBookDuration: 'Snitt tidsperiod att läsa ut en bok',
    statAvgSessionsPerBook: 'Snitt sessioner per bok läst',
    statPagesPerBook: 'Snitt sidor per bok läst',
    statLongestStreak: 'Längsta streak',
    statCurrentStreak: 'Nuvarande streak',
    statShortestSession: 'Kortaste session',
    statLongestSession: 'Längsta session',

    share: {
      finishsession: 'har precis avslutat en lässession!',
      finishbook: 'har precis läst ut en bok!',
      sessioninfo: 'Sessionsinfo',
      streak: 'Streak',
      sessions: 'Sessioner',
      quote: 'Citat',
      share: 'Dela',
      error:
        'Din enhet stöder inte direkt delning. Bilden kommer att laddas ner istället. Du kan dela den manuellt!',
    },

    timeperiod: 'Tidsperiod',
    alltime: 'Total',
    today: 'Idag',
    yesterday: 'Igår',
    thisweek: 'Denna vecka',
    lastweek: 'Förra veckan',
    thismonth: 'Denna månad',
    lastmonth: 'Förra månaden',
    thisyear: 'Detta år',
    lastyear: 'Förra året',

    emptyFindBook: 'Hitta en bok att läsa',
    emptyFindNewBook: 'Hitta en ny bok att läsa',
    emptyNoBookProgress:
      'Du har inte läst klart någon bok ännu, men du är på god väg.',
    emptyReading: 'Det finns ingen bok markerad som att den läses just nu.',
    emptyWantToRead: "Du har ingen bok i listan 'vill läsa'.",
    emptyNoBooks: 'Du har inte läst klart någon bok ännu.',
    emptyGoToBooks: 'Gå till mina böcker',
    emptyStats:
      "Få statistik genom att starta och avsluta lässessioner. För att starta en session måste du först ha en bok sparad i listan 'läser'.",
    emptyState: {
      reading: {
        quote: `Hur ska jag kunna veta det, när jag aldrig har försökt?`,
        author: 'Astrid Lindgren',
        book: 'Pippi går i affärer',
      },
      wanttoread: {
        quote:
          'Han kom som ett yrväder en aprilafton och hade ett höganäskrus i en svångrem om halsen.',
        author: 'August Strindberg',
        book: 'Hemsöborna',
      },
      read: {
        quote: `Det var, som en skygg fågel hade satt sig på hennes skuldra, och hon var rädd att skrämma den. Om hon rörde sig, då skulle fågeln flyga och sorgen få makt med henne.`,
        author: 'Selma Lagerlöf',
        book: 'En herrgårdssägen',
      },
      stats: {
        quote: `Han förde cykeln bredvid sig som ett stort ök, lastat med mattorna, genom ett ödsligt Sahara. Det var persiska mattor, vävda av tyska proletärer, förmedlade av en judinna med vit jättebarm, nu jagande fram svetten på en bondson från Humla by. Nu var han en länk i denna sällsamma kedja.`,
        author: 'Ivar Lo-Johansson',
        book: 'Kungsgatan',
      },
    },

    trophies: {
      firstbook: {
        name: 'Första boken!',
        desc: 'Läst klart din första bok.',
      },
      booksII: {
        name: 'Bokslukare II',
        desc: 'Läst ut 3 böcker.',
      },
      booksIII: {
        name: 'Bokslukare III',
        desc: 'Läst ut 6 böcker.',
      },
      booksIV: {
        name: 'Bokslukare IV',
        desc: 'Läst ut 12 böcker.',
      },
      streakI: {
        name: 'Streak I',
        desc: 'Läst 7 dagar i rad.',
      },
      streakII: {
        name: 'Streak II',
        desc: 'Läst 14 dagar i rad.',
      },
      streakIII: {
        name: 'Streak III',
        desc: 'Läst 30 dagar i rad.',
      },
      streakIV: {
        name: 'Streak IV',
        desc: 'Läst 60 dagar i rad.',
      },
      readerI: {
        name: 'Marathonläsare I',
        desc: 'Läst 30 minuter under samma dag.',
      },
      readerII: {
        name: 'Marathonläsare II',
        desc: 'Läst 1 timme under samma dag.',
      },
      readerIII: {
        name: 'Marathonläsare III',
        desc: 'Läst 2 timmar under samma dag.',
      },
      readerIV: {
        name: 'Marathonläsare IV',
        desc: 'Läst 3 timmar under samma dag.',
      },
      pagesI: {
        name: 'Bladvändare I',
        desc: 'Läst 100 sidor.',
      },
      pagesII: {
        name: 'Bladvändare II',
        desc: 'Läst 1.000 sidor.',
      },
      pagesIII: {
        name: 'Bladvändare III',
        desc: 'Läst 2.500 sidor.',
      },
      pagesIV: {
        name: 'Bladvändare IV',
        desc: 'Läst 5.000 sidor.',
      },
      timeI: {
        name: 'Tidsoptimist I',
        desc: 'Läst 1 timme.',
      },
      timeII: {
        name: 'Tidsoptimist II',
        desc: 'Läst 10 timmar.',
      },
      timeIII: {
        name: 'Tidsoptimist III',
        desc: 'Läst 50 timmar.',
      },
      timeIV: {
        name: 'Tidsoptimist IV',
        desc: 'Läst 100 timmar.',
      },
      sessionsI: {
        name: 'Läslus I',
        desc: 'Avslutat din första session.',
      },
      sessionsII: {
        name: 'Läslus II',
        desc: 'Avslutat 15 sessioner.',
      },
      sessionsIII: {
        name: 'Läslus III',
        desc: 'Avslutat 75 sessioner.',
      },
      sessionsIV: {
        name: 'Läslus IV',
        desc: 'Avslutat 150 sessioner.',
      },
    },

    effectiveDate: 'Gällande datum',
    tos: {
      intro:
        'Välkommen till Bookie! Genom att använda Bookie godkänner du följande villkor. Läs dem noggrant.',
      acceptance: 'Godkännande av villkor',
      acceptanceMessage:
        'Genom att gå in på eller använda Bookie, godkänner du att vara bunden av dessa användarvillkor. Om du inte godkänner någon del av dessa villkor, vänligen använd inte Bookie.',
      userdata: 'Användardata och integritet',
      userdataMessage:
        'Din integritet är viktig för oss. Genom att använda Bookie samtycker du till insamling, lagring och användning av dina uppgifter enligt vår integritetspolicy.',
      storage: 'Datalagring',
      storageMessage:
        'För att ge dig den bästa upplevelsen lagrar Bookie användardata, inklusive men inte begränsat till, läspreferenser, sessionsdata och användarinställningar, på Google Firebase. Genom att använda Bookie samtycker du till att din data lagras och behandlas i Firebase. Vi använder Firebase för att säkerställa att din data är tillgängliga på olika enheter och säkerhetskopieras säkert. Vi lagrar också vissa användarinställningar och sessionsdata i webbläsarens lokala lagring.',
      security: 'Säkerhet',
      securityMessage:
        'Även om vi vidtar rimliga försiktighetsåtgärder för att skydda din data är inget säkerhetssystem ogenomträngligt. Vi kan därför inte garantera absolut säkerhet för din data. Genom att godkänna dessa villkor, erkänner du att du använder Bookie på egen risk.',
      service: 'Friskrivning avseende tjänstens kontinuitet',
      serviceMessage: `Bookie är ett personligt hobbyprojekt som tillhandahålls "i befintligt skick" utan garanti för långsiktig tillgänglighet eller kontinuitet. Tjänsten kan ändras, pausas eller avslutas när som helst, utan förvarning eller ansvar gentemot användarna.`,
      changes: 'Ändringar av villkor',
      changesMessage:
        'Vi kan uppdatera dessa användarvillkor från tid till annan. Om ändringar görs, kommer vi att meddela dig genom att uppdatera "Gällande datum" högst upp på denna sida. Din fortsatta användning av Bookie efter sådana ändringar innebär att du accepterar de nya villkoren.',
    },
    pp: {
      intro:
        'På Bookie är din integritet vår högsta prioritet. Denna integritetspolicy förklarar hur vi samlar in, använder och skyddar din personliga information när du använder Bookie. Genom att använda Bookie godkänner du de metoder som beskrivs i denna policy.',
      informationHeader: 'Information vi samlar in',
      informationMessage:
        'Vi samlar in följande typer av information för att ge dig en personlig och sömlös läsupplevelse:',
      informationList1:
        'Personlig information: När du skapar ett konto samlar vi in ditt namn och din e-postadress.',
      informationList2:
        'Användningsdata: Vi samlar in information relaterad till dina interaktioner med appen, såsom dina läspreferenser, lässessioner och användningsmönster.',
      usageHeader: 'Hur vi använder din information',
      usageMessage:
        'Den information vi samlar in används enbart för att förbättra din upplevelse med Bookie. Specifikt använder vi din data för att:',
      usageList1: 'Visa statistik över din personliga läsning.',
      usageList2:
        'Synkronisera dina läsframsteg och preferenser över olika enheter.',
      usageList3: 'Ge dig tillgång till din sparade data när du loggar in.',
      usageExemptHeader: 'Viktigt, Bookie gör inte:',
      usageExemptList1: 'Säljer din personliga information till tredje part.',
      usageExemptList2:
        'Matar din data i algoritmer för att rekommendera böcker eller annat innehåll.',
      storageHeader: 'Datalagring och säkerhet',
      storageMessage:
        'Dina data lagras säkert i Google Firebase och webbplatsen serveras från GitHub.',
      userControlHeader: 'Användarkontroll: exportera och radera din data',
      userControlMessage: 'Vi tror på att ge dig full kontroll över din data:',
      userControlList1:
        'Dataexport: Du kan begära en export av din bokdata när som helst genom att använda den inbyggda exportfunktionen. Vi kommer att tillhandahålla en kopia av din data i CSV-format.',
      userControlList2:
        'Kontoborttagning: Om du vill radera ditt konto och all tillhörande data kan du göra det genom att använda den inbyggda kontoborttagningsfunktionen. När detta är klart kommer alla din data att raderas permanent.',
      dataRetentionHeader: 'Data lagringstid',
      dataRetentionMessage:
        'Vi behåller din data så länge ditt konto är aktivt eller så länge det behövs för att tillhandahålla våra tjänster. Om du väljer att radera ditt konto kommer din data att raderas permanent.',
      partiesHeader: 'Tredjepartstjänster',
      partiesMessage:
        'Bookie använder tredjepartstjänster, såsom Google Firebase och GitHub, för att lagra och hantera din data och för att tillhandahålla webbplatsen. Dessa tjänster styrs av deras egna integritetspolicyer.',
      changesHeader: 'Ändringar i denna integritetspolicy',
      changesMessage:
        'Vi kan uppdatera denna integritetspolicy från tid till annan. När vi gör ändringar, kommer vi att meddela dig genom att uppdatera "Gällande datum" högst upp på denna sida. Din fortsatta användning av Bookie efter eventuella ändringar innebär att du accepterar den nya policyn.',
    },
    superlatives: {
      l1: {
        first: 'Snyggt',
        second: 'Fint',
        third: 'Bra',
        fourth: 'Imponerande',
      },
      l2: {
        first: 'Fantastiskt',
        second: 'Underbart',
        third: 'Fantastiskt',
        fourth: 'Grymt',
      },
      l3: {
        first: 'Otroligt',
        second: 'Enastående',
        third: 'Anmärkningsvärt',
        fourth: 'Suveränt',
      },
      l4: {
        first: 'Fenomenalt',
        second: 'Häpnadsväckande',
        third: 'Extraordinärt',
        fourth: 'Episkt',
      },
      l5: {
        first: 'Legendariskt',
        second: 'Ostoppbart',
        third: 'Oövervinneligt',
        fourth: 'Överlägset',
      },
    },
    hero: {
      cta: 'Läs hur det fungerar',
      cta2: 'Kom igång nu',
      login: 'Logga in',
      subheader: 'Följ din framsteg och återupptäck glädjen i att läsa',
      introtext:
        'Bookie är den ultimata följeslagaren för bokälskare. Oavsett om du tar dig an din nästa roman eller försöker få bättre läsrutiner, håller Bookie dig motiverad med enkla verktyg för att spåra framsteg och fira dina prestationer.',
      howitworks: 'Så fungerar det',
      step1: 'Steg 1: Lägg till böcker i din hylla',
      step2: 'Steg 2: Börja läsa',
      step3: 'Steg 3: Se dina framsteg',
      step1text:
        'Sök snabbt efter titel, författare eller ISBN för att lägga till böcker i din virtuella bokhylla. Hittar du den inte? Lägg till boken manuellt för en smidig upplevelse.',
      step2text:
        'Starta en lässession med ett tryck. Spåra tid, antal lästa sidor och mer, samtidigt som du sjunker ner i dina favoritberättelser.',
      step3text:
        'Se detaljerad statistik och lås upp roliga prestationer. Arbeta mot en perfekt läsvecka genom att hålla ditt streak och vara konsekvent. Håll uppe tempot, bygg vanor och fira dina framsteg.',
      why: 'Varför Bookie?',
      whytext:
        'I dagens hektiska värld är det lätt att tappa bort sina läsmål eller glömma glädjen i att förlora sig i en fantastisk bok. Bookie hjälper dig att hålla dig konsekvent och inspirerad med personlig framstegsspårning, engagerande statistik och motiverande prestationer. Oavsett om du är en hängiven läsare eller just har börjat, gör Bookie din läsning till en rolig och givande upplevelse.',
      didyouknow: 'Visste du att?',
      didyouknowbullet1:
        'Genom att läsa 10 minuter varje dag kan du avsluta 10 böcker på ett år. Detta baseras på en genomsnittlig läshastighet på 45 sidor per timme och en genomsnittlig boklängd på cirka 270 sidor.',
      didyouknowbullet2:
        'Att läsa stärker hjärnan, ökar kreativiteten, förbättrar emotionell intelligens och berikar ditt ordförråd.',
    },
  },
};

export default translations;
